// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
      .button-container {
        display: flex !important;
        justify-content: space-between !important;
        margin: 10px 0px 0px 0px;
      }
    `, "",{"version":3,"sources":["webpack://./projects/ert/src/app/ert-firedepartment-bc-turnover/carryover-comments/carryover-comments-edit.component.ts"],"names":[],"mappings":";MACM;QACE,wBAAwB;QACxB,yCAAyC;QACzC,wBAAwB;MAC1B","sourcesContent":["\n      .button-container {\n        display: flex !important;\n        justify-content: space-between !important;\n        margin: 10px 0px 0px 0px;\n      }\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
